export default "__VITE_ASSET__2c11cf0c__"